// @flow

import { isNumber, toNumber } from 'lodash';

export const formatNumber = (n: number) =>
  isNumber(n) ? toNumber((n + 0.0001).toFixed(2)) : n;
